export default "__VITE_ASSET__BdAAat0S__"